import React from 'react';
import { Icon, IconProps } from '../Icon';

export const ChunkyPlusIcon: React.FC<Omit<IconProps, 'children'>> = (props) => {
    return (
        <Icon {...props}>
            <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 5.5a1.5 1.5 0 0 1 1.5 1.5v3.5h3.5a1.5 1.5 0 0 1 0 3h-3.5v3.5a1.5 1.5 0 0 1-3 0v-3.5h-3.5a1.5 1.5 0 0 1 0-3h3.5v-3.5A1.5 1.5 0 0 1 12 5.5z" />
            </svg>
        </Icon>
    );
};
